import styled from 'styled-components';
import { Form } from 'formik';

export default styled(Form)`
  .ant-form-item {
    margin-bottom: 12px;
    .ant-form-item-label {
      padding: 0 0 5px;
    }
  }
`;
